// extracted by mini-css-extract-plugin
export default {"newBadge":"_vhUa98thhdf1cwHrisX"};